export default "__VITE_ASSET__B$yQ0IaZ__"